import React, { JSX, ReactNode, useCallback } from "react";
import { DotItemDotProps, TooltipContentProps } from "recharts";
import { Box, Typography } from "@mui/material";
import { Palette, Sizes } from "../@shared/palette";
import { FlexBoxInline } from "../@shared/templates";

export type UseChartsResult = {
  getCustomTooltip: (props: TooltipContentProps) => ReactNode,
  getCustomDot: (index: number) => JSX.Element | null
}

export type UseChartsProps = {
  items: ChartItem[],
}

export type ChartItem = {
  label: string,
  key: string,
  color: string,
  postfix?: string
}

export const useCharts = (props: UseChartsProps) => {
  const getCustomTooltip = useCallback(({ active, payload, label }: TooltipContentProps) => {
    if (active && payload && payload.length) {
      return (
        <Box sx={{ backgroundColor: Palette.backgroundColorCard, padding: "5px", borderRadius: "4px" }}>
          <Typography sx={{ fontSize: Sizes.textSecondary, color: Palette.textColorSecondary }}>{`${label}`}</Typography>
          {props.items.map((item, index) => {
            return (
              <Typography sx={{ ...FlexBoxInline, fontSize: Sizes.textSecondary, color: item.color }}>
                {item.label}:
                <Typography sx={{ fontSize: Sizes.textSecondary, color: item.color }}>{`${payload[index]?.value ?? ""}${item.postfix ?? ""}`}</Typography>
              </Typography>
            );
          })}
        </Box>
      );
    }
    return null;
  }, [props.items]);

  const getCustomDot = useCallback((index: number) => {
    return ({ cx, cy }: DotItemDotProps) => {
      return <circle cx={cx} cy={cy} r={3} fill={props.items[index].color} />;
    }
  }, [props.items]);

  return {
    getCustomTooltip,
    getCustomDot
  }
}